import React from 'react';
import {
  useReactTable,
  createColumnHelper,
  getCoreRowModel,
} from '@tanstack/react-table';
import {formatNumberToInternational } from "../../../../utils/utils";

const getFormattedValue = (descricao, value, isDescricaoColumn = false) => {
  // Check if it's the descricao column, align left
  const textAlign = isDescricaoColumn ? 'left' : 'right';

  // Check if the descricao is "Transferência Internas(Conversoes)" and value is negative
  const isTransfer = descricao === 'Transferência Internas(Conversoes)';
  
  // If it's a transfer and value is negative, display the absolute value
  const displayValue = isTransfer && value && value.includes('-') ? value.replace('-', ''): value;
  // Check for special "Saldo" rows that need to be bolded and have a background color
  const isSaldoSpecial =
    descricao === 'SALDO TOTAL' || descricao === 'TOTAL DOS RECEBIMENTOS' || descricao === 'TOTAL GERAL';

  return {
    displayValue,
    styles: {
      fontWeight: isSaldoSpecial ? 'bold' : 'normal',
      backgroundColor: isSaldoSpecial ? '#f0f0f0' : 'transparent',
      color: isTransfer && value && value.includes('-') ? 'red' : 'inherit', // Red color for negative values in "Transferência Internas"
      textAlign: textAlign,
    },
  };
};

const RecitaReportTable = (props) => {
  const { tableData } = props;
  const [data, setData] = React.useState(() => [...tableData]);
  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.group({
      header: 'DESCRIÇÃO',
      columns: [
        columnHelper.accessor('description', {
          header: 'BALANÇO DO MÊS ANTERIOR',
          cell: info => {
            const { displayValue, styles } = getFormattedValue(info.getValue(), info.getValue(), true); // Pass true for descricao
            return <div style={styles}>{displayValue}</div>;
          },
        }),
      ],
    }),
    columnHelper.group({
      header: 'MOEDAS',
      columns: [
        columnHelper.accessor('totalJpy', {
          header: 'YJP',
          cell: info => {
            const { displayValue, styles } = getFormattedValue(info.row.original.description, formatNumberToInternational(info.getValue()));
            return <div style={styles}>{displayValue}</div>;
          },
        }),
        columnHelper.accessor('totalUsd', {
          header: 'USD',
          cell: info => {
            const { displayValue, styles } = getFormattedValue(info.row.original.description, formatNumberToInternational(info.getValue()));
            return <div style={styles}>{displayValue}</div>;
          },
        }),
        columnHelper.accessor('totalEur', {
          header: 'EUR',
          cell: info => {
            const { displayValue, styles } = getFormattedValue(info.row.original.description, formatNumberToInternational(info.getValue()));
            return <div style={styles}>{displayValue}</div>;
          },
        }),
      ],
    }),
    columnHelper.accessor('totalAkz', {
      header: 'KWANZAS',
      cell: info => {
        const { displayValue, styles } = getFormattedValue(info.row.original.descricao, formatNumberToInternational(info.getValue()));
        return <div style={styles}>{displayValue}</div>;
      },
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div>
      <table
        border="1"
        style={{
          borderCollapse: 'collapse',
          width: '100%',
          border: '1px solid black',
        }}
      >
        <thead>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header, index) => (
                <th
                  key={header.id}
                  colSpan={header.colSpan}
                  style={{
                    padding: '4px',
                    textAlign: 'center',
                    fontSize: '14px',
                    backgroundColor: '#f0f0f0',
                    borderBottom: '1px solid #000',
                    borderRight: index < headerGroup.headers.length - 1 ? '1px solid #000' : '',
                  }}
                >
                  {header.isPlaceholder ? null : header.column.columnDef.header}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map(row => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell, index) => (
                <td
                  key={cell.id}
                  style={{
                    padding: '4px',
                    fontSize: '12px',
                    textAlign: 'center',
                    borderBottom: '1px solid #000',
                    borderRight: index < row.getVisibleCells().length - 1 ? '1px solid #000' : '',
                  }}
                >
                  {cell.column.columnDef.cell?.(cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RecitaReportTable;
